import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES, LOCAL_STORAGE } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { UserService } from "../User/services/UserService";
import { UserStatus } from "../User/models/UserStatus";
import AssignServiceTemplate from "./components/AssignServiceTemplate/AssignServiceTemplate.vue";
import AddTask from "@/modules/Tasks/components/AddTask/AddTask.vue";
import ServicesView from "./components/ServicesView/ServicesView.vue";
import {
  LIST_QUERY,
  MAX_WIDTH_MODALS,
  POP_STATE_EVENT,
  PROFILE_CONSTANTS,
  PROFILE_CRUMBS_CONSTANTS
} from "./constants/ProfileConstants";
import { RoleInfo } from "../Roles/models/RoleInfo";
import { RolesService } from "../Roles/services/RolesService";
import {
  QUERY_STATE_ACTIVE_PATIENT,
  USER_CONSTANTS,
  USER_ACCESS,
  USER_STATES
} from "../User/constants/UserConstants";
import { TASK_CONSTANTS } from "../Tasks/constants/TaskConstants";
import { InfoGroupService } from "../InfoGroup/services/InfoGroupService";
import {
  INFO_GROUPS_ACCESS,
  INFO_GROUP_CONSTANTS
} from "../InfoGroup/constants/InfoGroupConstants";
import { NotificationParams } from "../Notification/models/NotificationParams";
import { USER_TEMP_CONSTANTS } from "../UserTemplate/constants/UserTemplateConstants";
import {
  SERVICES_ACCESS,
  SERVICES_CONTANTS,
  SERVICE_STATES
} from "../Services/constants/ServicesConstants";
import { DashboardService } from "../Dashboards/AdminDashboard/services/DashboardService";
import {
  NOTIFICATION_ACCESS,
  NOTIFICATION_CONFIG
} from "../Notification/constants/NotificationConstants";
import {
  ACTION_EVENT,
  ACTION_MESSAGE,
  DASHBOARD_ACCESS
} from "../Dashboards/AdminDashboard/constants/ActionConstants";
import { NotificationConfig } from "@/modules/Notification/models/NotificationConfig";
import { ActionId } from "../Dashboards/AdminDashboard/models/ActionId";
import { ActionParameters } from "../Dashboards/AdminDashboard/models/ActionParameters";
import { NavigationGuardNext } from "vue-router";
import store from "@/store";
import ListServices from "./components/ListServices/ListServices.vue";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import {
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { mapGetters } from "vuex";
import TitleChip from "@/shared/components/TitleChip/TitleChip.vue";
import { FILE } from "@/shared/constants/FileConstants";
import AddFileModal from "@/modules/Profile/components/AddFileModal/AddFileModal.vue";
import { ListService } from "../List/services/ListService";
import { ListCategory } from "@/shared/models/ListCategory";
import { LIST_ACCESS, LIST_CONSTANTS } from "../List/constants/ListConstants";
import firebase from "firebase/app";
import "firebase/storage";
import { DocumentService } from "../Document/services/DocumentService";
import { DocumentSaveDTO } from "../Document/models/DocumentSaveDTO";
import { DocumentUpdateDTO } from "../Document/models/DocumentUpdateDTO";
import { Response } from "@/shared/models/Response";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { ServicesService } from "../Services/services/ServicesService";
import NotificationModal from "../Notification/components/NotificationModal/NotificationModal.vue";
import MedicalOrder from "../MedicalOrder/MedicalOrder.vue";
import { ServiceHeaderData } from "../Services/models/ServiceHeaderData";
import { ASIGN_APPOINTMENT } from "./components/Appointment/components/TimeOutModal/constants/TimeOutConstants";
import Appointment from "./components/Appointment/Appointment.vue";
import { Utils } from "@/shared/utils/utils";
import EditPatient from "./components/EditPatient/EditPatient.vue";
import ImgAvatar from "./../../shared/components/ImgAvatar/ImgAvatar.vue";
import { ROLES_ACCESS } from "../Roles/constants/RoleConstants";
import { DOCUMENTS_ACCESS } from "../Document/constants/DocumentConstants";
import { AxiosError } from "axios";
import { FormsService } from "@/modules/Forms/services/FormService";
import { FormsData } from "@/modules/Forms/models/FormsData";
import ReportAddTask from "@/shared/components/ReportAddTask/ReportAddTask.vue";
import { ReportAddTaskData } from "@/shared/components/ReportAddTask/models/ReportAddTaskData.model";
import { MedicalAppointmentService } from "../MedicalAppointment/services/MedicalAppointmentService";
import { NotificationService } from "../Notification/services/NotificationService";
import { ListQuery } from "../List/models/ListQuery";
import { List } from "../List/models/List";
import { Option } from "@/modules/List/models/Option";
import { DEFAULT_RECIPIENTS_KEYS } from "@/shared/components/MessageRecipients/constants/RecipientsConstants";

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "Profile",
  components: {
    AddTask,
    ServicesView,
    AssignServiceTemplate,
    ListServices,
    TitleChip,
    AddFileModal,
    ModalTemplate,
    NotificationModal,
    MedicalOrder,
    Appointment,
    EditPatient,
    ImgAvatar,
    ReportAddTask
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView",
      refreshProfileServices: "getRefreshProfileServices",
      profileCrumbs: "getProfileCrumbles",
      generalData: "getGeneralDataTasks"
    })
  }
})
export default class Profile extends Vue {
  @Inject() userService!: UserService;
  @Inject() rolesService!: RolesService;
  @Inject() infoGroupService!: InfoGroupService;
  @Inject() dashboardService!: DashboardService;
  @Inject() listService!: ListService;
  @Inject() documentService!: DocumentService;
  @Inject() servicesService!: ServicesService;
  @Inject() formsService!: FormsService;
  @Inject() medicalAppointmentService!: MedicalAppointmentService;
  @Inject() notificationService!: NotificationService;

  dataToMainView!: MenuDataStructure;
  profileCrumbs!: MenuDataStructure;
  refreshProfileServices!: boolean;

  CREATE_SERVICE_BTN = SERVICES_CONTANTS.BUTTON.ASSIGN_SERVICE;
  CREATE_TASK_BTN = TASK_CONSTANTS.BUTTONS.CREATE_BTN;
  CREATE_NOTI_BTN = NOTIFICATION_CONFIG.LABEL.CREATE_NOTIFICATION;
  UPLOAD_DOC_BTN = FILE.LABEL.UPLOAD_DOCUMENT;
  SHARE_DOC_BTN = FILE.LABEL.SHARE_DOCUMENT;
  DOCUMENT = PROFILE_CONSTANTS.PROFILE_ITEMS.DOCUMENT;
  EMAIL = PROFILE_CONSTANTS.PROFILE_ITEMS.EMAIL;
  COMPLETE_SERVICE_BTN = SERVICES_CONTANTS.BUTTON.COMPLETE_SERVICE;
  CREATE_ORDER_BTN = PROFILE_CONSTANTS.CREATE_ORDER;
  MAX_WIDTH = MAX_WIDTH_MODALS;
  ASIGN_APPOINTMENT = ASIGN_APPOINTMENT;
  EDIT_LABEL = PROFILE_CONSTANTS.LABELS.EDIT;
  COMPLETED_SERVICE = SERVICE_STATES.COMPLETED;
  primaryBtnClassRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  chipTitle = PROFILE_CONSTANTS.TABS.SERVICES;
  switchClass = STYLE_CLASSES.SWITCH;
  userStates = USER_STATES;
  addTask = false;
  addService = false;
  notificationDialog = false;

  uploadDialog = false;
  dialogAssign = false;
  isDocument = false;
  isScheduledAvailable = false;
  userToAssign = "";
  isBackWithButton = false;

  userId = "";
  tab = "tab-3";
  userInfo: UserStatus = {
    id: "",
    userEmail: "",
    userPhone: "",
    userName: "",
    userState: "",
    name: ""
  };

  userInfoParams: NotificationParams[] = [];
  userRoleList: RoleInfo[] = [];
  categories: ListCategory[] = [];
  showServiceCards = true;

  userIdArray: ActionId[] = [];
  notifications: NotificationConfig[] = [];
  dialogConfirmation = false;
  refreshServiceCards = false;
  getMoreServices = false;
  serviceSelected = "";

  modalConfirmationText =
    PROFILE_CONSTANTS.DIALOG_MESSAGES.COMPLETE_SERVICE_TEXT;
  modalConfirmationTitle =
    PROFILE_CONSTANTS.DIALOG_MESSAGES.COMPLETE_SERVICE_TITLE;
  showCompleteButton = false;
  orderDialog = false;
  userDocument = "";
  dataInProfileFromList: ServiceHeaderData[] = [];
  appointmentDialog = false;
  showEditPatient = false;
  generalData!: FormsData[];
  countSelectUsers = 1;
  reportTask: Array<ReportAddTaskData> = [];
  masiveTaskResponse = false;
  appointmentSelected = "";
  cancelServiceId?: string;
  isOnline: boolean | undefined = false;
  fireNotificationModalMsg = "";

  async mounted() {
    if (this.$route.params.id) {
      this.userId = this.$route.params.id;
      this.userIdArray = [
        {
          id: this.userId
        }
      ];
      await this.getUserData();
    } else {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      this.$router.push("/");
    }

    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.PROFILE,
      type: PANEL_INFO_CONSTANTS.TYPE.SERVICE,
      action: PANEL_INFO_CONSTANTS.ACTION.SHOW,
      id: this.userId,
      data: {
        id: "",
        type: "",
        name: "",
        progress: 0
      }
    });
    await this.getRoles();
    await this.loadInfoGroupFieldsByName();
    await this.loadCategories();
    await this.getPhoneStatus();

    this.serviceSelected = this.$route.params.service;
    store.commit(STORE_CONSTANTS.PROFILE_CRUMBS, {
      from: PROFILE_CRUMBS_CONSTANTS.FROM.PROFILE,
      type: PROFILE_CRUMBS_CONSTANTS.TYPE.INITIAL,
      action: PROFILE_CRUMBS_CONSTANTS.ACTION.INITIAL_ROUTE,
      id: this.userId,
      data: { userName: this.userInfo.name }
    });

    this.$router.beforeEach((to, from, next) => {
      if (!this.showServiceCards && window.event?.type == POP_STATE_EVENT) {
        this.unselectService();
        next(false);
        return;
      }
      store.commit(STORE_CONSTANTS.PROFILE_CRUMBS, {} as MenuDataStructure);
      if (this.$refs.servicesComponent) {
        (this.$refs.servicesComponent as Vue & {
          prepareToExit: (next: NavigationGuardNext) => void;
        }).prepareToExit(next);
      } else {
        next();
      }
    });
    const taskId = localStorage.getItem(LOCAL_STORAGE.TASK_ID);
    if (taskId) {
      localStorage.removeItem(LOCAL_STORAGE.TASK_ID);
      store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
        from: PANEL_INFO_CONSTANTS.FROM.PROFILE,
        type: PANEL_INFO_CONSTANTS.TYPE.TASK,
        action: PANEL_INFO_CONSTANTS.ACTION.SHOW,
        id: this.userId,
        data: { id: taskId }
      });
    }
  }

  async destroyed() {
    store.commit(STORE_CONSTANTS.SERVICE_CHANGE_VALIDATION, false);
    store.commit(STORE_CONSTANTS.REFRESH_SERVICE_TEMPLATE, false);
    store.commit(STORE_CONSTANTS.USER_STATE, "");
  }

  @Watch("userInfo.userState")
  validateUserState() {
    if (this.userInfo.userState === this.userStates.ACTIVE) {
      store.commit(STORE_CONSTANTS.USER_STATE, this.userInfo.userState);
    }
  }

  @Watch("profileCrumbs")
  handleProfileCrumbles() {
    if (
      this.profileCrumbs.from == PROFILE_CRUMBS_CONSTANTS.FROM.ROUTE_MAP &&
      this.profileCrumbs.action ==
        PROFILE_CRUMBS_CONSTANTS.ACTION.UPDATE_ROUTE &&
      this.profileCrumbs.type == PROFILE_CRUMBS_CONSTANTS.TYPE.SERVICE_REMOVED
    ) {
      this.unselectService();
    }
  }
  async getUserData() {
    try {
      const responseData = await this.userService.getUserBasicInfo(this.userId);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.userInfo = responseData.data;
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getRoles() {
    try {
      const responseData = await this.rolesService.getRoles(
        QUERY_STATE_ACTIVE_PATIENT
      );

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.userRoleList = responseData.data;
      } else {
        Snackbar.popInfo(USER_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_ROLES);
        this.userRoleList = [];
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${ROLES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async loadInfoGroupFieldsByName() {
    try {
      const responseData = await this.infoGroupService.getInfoGroupFieldByName(
        INFO_GROUP_CONSTANTS.INFO_GROUP_BASIC_NAME
      );
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.userInfoParams = responseData.data;
      } else {
        Snackbar.popInfo(USER_TEMP_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_GROUPS);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${INFO_GROUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async loadCategories() {
    try {
      const filterQuery: ListQuery = {};
      filterQuery.isCategoryList = [LIST_QUERY.ACTIVO];
      filterQuery.listType = [LIST_QUERY.PACIENTE];
      filterQuery.isDocumentCategoryList = [LIST_QUERY.ACTIVO];

      const responseData = await this.listService.getChart(filterQuery);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.categories = responseData.data.listArray.map((item: List) => {
          return {
            idReference: item.id as string,
            name: item.name as string,
            subcategories: item.options.map((option: Option) => ({
              key: option.id,
              name: option.value
            }))
          };
        });
      } else {
        Snackbar.popInfo(LIST_CONSTANTS.DIALOG_MESSAGE.CATEGORY_NOT_FOUND);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async sendAction(newAction: ActionParameters, openModal: boolean) {
    try {
      const responseData = await this.dashboardService.applyUserActions(
        newAction
      );

      if (
        responseData.code === Http.Ok ||
        responseData.code === Http.PartialContent
      ) {
        if (responseData?.data?.data) {
          const data = responseData.data.data;
          if (
            responseData &&
            Array.isArray(data) &&
            data.some(element => element.validate == false)
          ) {
            Snackbar.popInfo(ACTION_MESSAGE.FAILED);
          } else {
            newAction.notificationData
              ? (this.fireNotificationModalMsg = responseData.message)
              : (this.fireNotificationModalMsg = "");
            Snackbar.popSuccess(responseData.message);
          }
          this.notificationDialog = false;
        } else {
          newAction.notificationData
            ? (this.fireNotificationModalMsg = responseData.message)
            : (this.fireNotificationModalMsg = "");
          Snackbar.popSuccess(responseData.message);
        }
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }

      this.reportTask = responseData.data?.data;
      this.masiveTaskResponse = openModal;

      if (newAction.type == ACTION_EVENT.TASK) {
        await this.getData();
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${DASHBOARD_ACCESS.POST}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  openAddTask() {
    this.addTask = true;
  }

  hideAddTask() {
    this.addTask = false;
  }

  hideSavedTask() {
    this.addTask = false;
    store.commit(STORE_CONSTANTS.TASK_REFRESH, true);
  }

  openAddService() {
    this.dialogAssign = true;
  }

  handleCloseAssignService() {
    this.dialogAssign = false;
  }

  handleCloseNotification() {
    this.notificationDialog = false;
  }

  dataInProfile(data: ServiceHeaderData[]) {
    this.dataInProfileFromList = [...data];
  }

  sendToMainView(data: MenuDataStructure) {
    if (
      data.action === PANEL_INFO_CONSTANTS.ACTION.FILL &&
      data.type === PANEL_INFO_CONSTANTS.TYPE.SERVICE
    ) {
      this.showServiceCards = false;
      this.chipTitle = data.data.name;
      this.showCompleteButton =
        data.data.progress > 0 && data.data.state != SERVICE_STATES.CANCELED;
      this.serviceSelected = data.data.id;

      store.commit(STORE_CONSTANTS.TO_MAIN_VIEW, data);
      store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
        from: PANEL_INFO_CONSTANTS.FROM.PROFILE,
        type: PANEL_INFO_CONSTANTS.TYPE.SERVICE,
        action: PANEL_INFO_CONSTANTS.ACTION.SHOW,
        data: data.data,
        id: this.userId
      });
      store.commit(STORE_CONSTANTS.PROFILE_CRUMBS, {
        from: PROFILE_CRUMBS_CONSTANTS.FROM.PROFILE,
        type: PROFILE_CRUMBS_CONSTANTS.TYPE.SERVICE_ADDED,
        action: PROFILE_CRUMBS_CONSTANTS.ACTION.UPDATE_ROUTE,
        id: this.userId,
        data: { userName: this.userInfo.name, service: data.data.name }
      });
    } else if (
      data.action === PANEL_INFO_CONSTANTS.ACTION.COMPLETE &&
      data.type === PANEL_INFO_CONSTANTS.TYPE.SERVICE
    ) {
      this.serviceSelected = data.data.id;
      this.completeService();
    } else if (
      data.action === PANEL_INFO_CONSTANTS.ACTION.CANCEL_SERVICE &&
      data.type === PANEL_INFO_CONSTANTS.TYPE.SERVICE
    ) {
      this.appointmentSelected = data.data.medicalAppointment;
      this.serviceSelected = data.data.id;
      this.cancelServiceId = data.data.id;
      this.cancelService();
    }
  }

  @Watch("refreshProfileServices")
  refreshProfileServicesHandler() {
    this.updateServices();
  }

  @Watch("dataToMainView")
  async dataToMainViewHandler() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type == PANEL_INFO_CONSTANTS.TYPE.SERVICE &&
      this.dataToMainView.action === PANEL_INFO_CONSTANTS.ACTION.FILL
    ) {
      this.chipTitle = this.dataToMainView.data.name;
      this.showCompleteButton =
        this.dataToMainView.data.progress > 0 &&
        this.dataToMainView.data.state != SERVICE_STATES.CANCELED;
      this.serviceSelected = this.dataToMainView.data.id;
      store.commit(STORE_CONSTANTS.PROFILE_CRUMBS, {
        from: PROFILE_CRUMBS_CONSTANTS.FROM.PROFILE,
        type: PROFILE_CRUMBS_CONSTANTS.TYPE.SERVICE_ADDED,
        action: PROFILE_CRUMBS_CONSTANTS.ACTION.UPDATE_ROUTE,
        id: this.userId,
        data: {
          userName: this.userInfo.name,
          service: this.dataToMainView.data.name
        }
      });
    } else if (
      this.dataToMainView.action === PANEL_INFO_CONSTANTS.ACTION.COMPLETE &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SERVICE
    ) {
      this.serviceSelected = this.dataToMainView.data.id;
      await this.completeService();
    } else if (
      this.dataToMainView.action ===
        PANEL_INFO_CONSTANTS.ACTION.SHOW_COMPLETE_BTN &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SERVICE
    ) {
      this.showCompleteButton = true;
    } else if (
      this.dataToMainView.action ===
        PANEL_INFO_CONSTANTS.ACTION.CANCEL_SERVICE &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SERVICE
    ) {
      this.serviceSelected = this.dataToMainView.data.id;
      this.appointmentSelected = this.dataToMainView.data.medicalAppointment;
      this.cancelServiceId = this.dataToMainView.data.id;
      await this.cancelService();
    }
    if (
      this.dataToMainView.data.state != undefined &&
      (this.dataToMainView.data.state == this.COMPLETED_SERVICE ||
        this.dataToMainView.data.state == SERVICE_STATES.CANCELED)
    ) {
      this.showServiceCards = false;
      this.showCompleteButton = false;
    }
  }

  get isMobile() {
    return (
      this.$vuetify.breakpoint.name === "sm" ||
      this.$vuetify.breakpoint.name === "xs"
    );
  }

  showUploadDialog() {
    this.uploadDialog = true;
  }

  closeUploadDialog() {
    this.uploadDialog = false;
  }

  async uploadDocument(
    file: File,
    fileName: string,
    fileType: string,
    category: ListCategory,
    subCategory: { key: string; name: string }
  ) {
    this.closeUploadDialog();
    const documentId = await this.createDocumentRecord(
      fileName,
      fileType,
      category,
      subCategory.key
    );

    if (documentId) {
      await this.uploadDocumentToCloud(documentId, fileType, file);
    }
  }

  async createDocumentRecord(
    fileName: string,
    fileType: string,
    category: ListCategory,
    subCategory: string
  ) {
    try {
      const body: DocumentSaveDTO = {
        categoryId: category.idReference,
        category: category.name,
        fileName: `${fileName}.${fileType}`,
        type: fileType,
        subCategory: subCategory,
        userId: this.userInfo.id
      };
      const response = await this.documentService.createDocumentRecord(body);
      if (response.code === Http.Ok) {
        return response.data;
      } else {
        Snackbar.popError(FILE.SNACKBAR.UPLOAD_FAILED);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${DOCUMENTS_ACCESS.POST}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async uploadDocumentToCloud(
    documentId: string,
    fileType: string,
    file: File
  ) {
    try {
      const storageRef = firebase.storage().ref();
      const response = await storageRef
        .child(
          `${Utils.getClientStoragePath()}/${FILE.FILE_STORAGE_FOLDER}/${
            this.userInfo.id
          }/${documentId}.${fileType}`
        )
        .put(file);

      if (response) {
        const filePath = (await response.ref.getDownloadURL()).toString();
        const updateResponse = await this.updateDocumentPath(
          documentId,
          filePath
        );

        if (updateResponse.code === Http.Ok) {
          Snackbar.popSuccess(FILE.SNACKBAR.UPLOAD);
        } else {
          await this.deleteFileFromStorage(documentId);
          await this.deleteFailedDocument(documentId);
        }
      } else {
        await this.deleteFailedDocument(documentId);
      }
    } catch (error) {
      const METHOD = Utils.getMethodHTTP(
        error as AxiosError
      ) as keyof typeof DOCUMENTS_ACCESS;
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${DOCUMENTS_ACCESS[METHOD]}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async updateDocumentPath(
    documentId: string,
    filePath: string
  ): Promise<Response<void>> {
    const documentUpdateDTO: DocumentUpdateDTO = {
      documentId: documentId,
      storagePath: filePath
    };
    return await this.documentService.updateDocumentPath(documentUpdateDTO);
  }

  async deleteFailedDocument(documentId: string) {
    const response = await this.documentService.deleteFailedDocument(
      documentId
    );
    if (response.code === Http.Ok) {
      Snackbar.popError(FILE.SNACKBAR.UPLOAD_FAILED);
    } else {
      Snackbar.popError(FILE.SNACKBAR.DELETE_FAILED);
    }
  }

  async deleteFileFromStorage(documentId: string) {
    const storageRef = firebase
      .storage()
      .ref(
        `${Utils.getClientStoragePath()}/${FILE.FILE_STORAGE_FOLDER}/${
          this.userInfo.id
        }/${documentId}`
      );
    await storageRef.delete();
  }

  openNotificationDialog() {
    this.isScheduledAvailable = true;
    this.notificationDialog = true;
  }

  async completeService() {
    try {
      const response = await this.servicesService.completeService(
        this.serviceSelected
      );

      if (response.code === Http.Ok) {
        this.chipTitle = PROFILE_CONSTANTS.TABS.SERVICES;
        this.showServiceCards = true;

        this.refreshLateralMenu(true);
        this.serviceSelected = "";
        store.commit(STORE_CONSTANTS.PROFILE_CRUMBS, {
          from: PROFILE_CRUMBS_CONSTANTS.FROM.PROFILE,
          type: PROFILE_CRUMBS_CONSTANTS.TYPE.SERVICE_REMOVED,
          action: PROFILE_CRUMBS_CONSTANTS.ACTION.UPDATE_ROUTE
        });

        Snackbar.popSuccess(response.message);
      } else {
        Snackbar.popWarning(response.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.PUT}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  refreshLateralMenu(restart: boolean) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.PROFILE,
      type: PANEL_INFO_CONSTANTS.TYPE.SERVICE,
      action: PANEL_INFO_CONSTANTS.ACTION.REFRESH,
      data: { restart }
    });
  }

  handleModalCancel() {
    this.dialogConfirmation = false;
  }

  async handleModalAccept() {
    this.handleModalCancel();
    await this.completeService();
  }

  showCompleteServiceModal() {
    this.modalConfirmationText =
      PROFILE_CONSTANTS.DIALOG_MESSAGES.COMPLETE_SERVICE_TEXT;
    this.modalConfirmationTitle =
      PROFILE_CONSTANTS.DIALOG_MESSAGES.COMPLETE_SERVICE_TITLE;
    this.dialogConfirmation = true;
  }

  updateServices() {
    this.refreshServiceCards = !this.refreshServiceCards;
    this.refreshLateralMenu(false);
  }

  acceptNotification(notification: NotificationConfig) {
    const multipleRecipients: ActionId[] = [];
    notification.recipients.dependencyUsers.forEach((user: any) => {
      if (user) {
        const userCustom = { id: user.id, ref: user.id };
        multipleRecipients.push(userCustom);
      }
    });
    notification.recipients.defaultRecipients.forEach((recipient: any) => {
      if (recipient) {
        if (
          recipient == DEFAULT_RECIPIENTS_KEYS.USER ||
          recipient.param == DEFAULT_RECIPIENTS_KEYS.USER
        ) {
          multipleRecipients.push({ id: this.userId, ref: this.userId });
        } else if (
          [
            DEFAULT_RECIPIENTS_KEYS.CHANGED_BY,
            DEFAULT_RECIPIENTS_KEYS.CREATED_BY
          ].includes(recipient.param)
        ) {
          const user = localStorage.getItem(LOCAL_STORAGE.UID) || "";
          multipleRecipients.push({ id: user, ref: user });
        }
      }
    });
    const action: ActionParameters = {
      ids: [{ id: this.userId, ref: this.userId }],
      type: ACTION_EVENT.NOTIFICATION,
      notifications: [notification]
    };
    if (multipleRecipients.length > 0) {
      const recipients = Array.from(
        new Map(multipleRecipients.map(item => [item.id, item])).values()
      );
      action.ids = recipients;
    }
    this.sendAction(action, false);
    this.notificationDialog = false;
  }

  executeTaskAction(taskAction: ActionParameters) {
    this.sendAction(taskAction, true);
    this.addTask = false;
  }

  cancelNotification() {
    this.notificationDialog = false;
  }
  alertNoPatientRol() {
    Snackbar.popError(ACTION_MESSAGE.NO_PATIENT_ROL);
    this.closeOrderModal();
  }
  closeOrderModal() {
    this.userDocument = "";
    this.orderDialog = false;
    this.updateServices();
  }
  fireOrderModal() {
    this.userDocument = this.userInfo.userDocument as string;
    this.orderDialog = true;
  }

  showAppointmentDialog() {
    this.appointmentDialog = true;
  }

  hideAppointmentModal() {
    this.appointmentDialog = false;
    this.updateServices();
  }

  showPatienInfo() {
    this.showEditPatient = true;
  }

  async onCloseModal(refresUserData: boolean) {
    this.showEditPatient = false;
    if (refresUserData) await this.getUserData();
  }

  unselectService() {
    store.commit(STORE_CONSTANTS.PROFILE_CRUMBS, {
      from: PROFILE_CRUMBS_CONSTANTS.FROM.PROFILE,
      type: PROFILE_CRUMBS_CONSTANTS.TYPE.SERVICE_REMOVED,
      action: PROFILE_CRUMBS_CONSTANTS.ACTION.UPDATE_ROUTE
    });

    this.showServiceCards = !this.showServiceCards;
    this.serviceSelected = "";
    this.refreshLateralMenu(true);
    this.chipTitle = PROFILE_CONSTANTS.TABS.SERVICES;
  }

  async getData() {
    try {
      store.commit(STORE_CONSTANTS.GENERAL_DATA_TASKS, []);
      const data = await this.formsService.userForms(this.userId);

      if (data.code == Http.Found && data.data !== undefined) {
        store.commit(STORE_CONSTANTS.GENERAL_DATA_TASKS, data.data);

        const dataToMainView = {
          from: PANEL_INFO_CONSTANTS.FROM.PANEL,
          type: PANEL_INFO_CONSTANTS.TYPE.TASK,
          action: PANEL_INFO_CONSTANTS.ACTION.SHOW,
          data: {
            taskNumber: data.data.length
          }
        };

        store.commit(STORE_CONSTANTS.TO_MAIN_VIEW, dataToMainView);
        return true;
      }
    } catch (error) {
      return false;
    }

    return false;
  }

  closeReportTask() {
    this.reportTask = [];
    this.masiveTaskResponse = false;
  }

  async cancelService() {
    try {
      this.showServiceCards = true;
      this.showCompleteButton = false;
      const response = await this.servicesService.cancelService(
        this.serviceSelected
      );

      if (response.code === Http.Ok) {
        this.showServiceCards = true;
        this.chipTitle = PROFILE_CONSTANTS.TABS.SERVICES;

        this.refreshLateralMenu(true);
        this.serviceSelected = "";
        this.cancelServiceId = undefined;
        store.commit(STORE_CONSTANTS.PROFILE_CRUMBS, {
          from: PROFILE_CRUMBS_CONSTANTS.FROM.PROFILE,
          type: PROFILE_CRUMBS_CONSTANTS.TYPE.SERVICE_REMOVED,
          action: PROFILE_CRUMBS_CONSTANTS.ACTION.UPDATE_ROUTE
        });

        Snackbar.popSuccess(response.message);
      } else {
        Snackbar.popWarning(response.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.PUT}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async onScrollCenter(event: Event) {
    const target = event.target as HTMLElement;
    if (target.scrollTop + target.clientHeight + 5 >= target.scrollHeight) {
      target.scrollTop -= 3;
      this.getMoreServices = !this.getMoreServices;
    }
  }

  async getPhoneStatus() {
    try {
      this.isOnline = undefined;
      let phoneExist;
      if (this.userInfo.userPhone) {
        phoneExist = this.userInfo.userPhone;
      } else {
        phoneExist = await this.userService.getOtherPhone(this.userId);
      }
      const response = await this.notificationService.getPhoneStatus(
        phoneExist
      );
      if (response.code === Http.Found && response.data) {
        this.isOnline = response.data.state ?? false;
      } else {
        this.isOnline = false;
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${NOTIFICATION_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;
      this.isOnline = false;
      Snackbar.popError(errorMessage);
    }
  }
}
